import { __awaiter, __generator } from "tslib";
import { fetchSFCCSetting, fetchSiteFeatures } from '../../site-settings';
var PRICING_API_CONFIG = {
    baseUrl: '',
    marketLocale: '',
    isSFCCPricingOn: false,
    sfccBaseUrl: '',
};
export var getPricingApiConfig = function () {
    return PRICING_API_CONFIG;
};
export var setPricingApiConfig = function (config) { return __awaiter(void 0, void 0, void 0, function () {
    var isSFCCPricingOn, setting, isSettingFilled;
    return __generator(this, function (_a) {
        switch (_a.label) {
            case 0:
                PRICING_API_CONFIG.baseUrl = config.baseUrl;
                PRICING_API_CONFIG.marketLocale = config.marketLocale;
                return [4 /*yield*/, fetchSiteFeatures(["SfccPrice" /* SfccPrice */])];
            case 1:
                isSFCCPricingOn = (_a.sent())[0].value;
                PRICING_API_CONFIG.isSFCCPricingOn = isSFCCPricingOn;
                if (!isSFCCPricingOn) {
                    return [2 /*return*/];
                }
                return [4 /*yield*/, fetchSFCCSetting()];
            case 2:
                setting = _a.sent();
                isSettingFilled = setting && Object.keys(setting).length > 0;
                if (isSettingFilled) {
                    PRICING_API_CONFIG.baseUrl = setting.shopApiBaseUrl || '';
                    PRICING_API_CONFIG.sfccBaseUrl = setting.sfccBaseUrl || '';
                    if (!PRICING_API_CONFIG.baseUrl) {
                        console.warn("SFCC Shop API URL is not set.");
                    }
                    PRICING_API_CONFIG.marketLocale = setting.shopApiLocale || config.marketLocale;
                }
                else {
                    console.warn('SFCC Search settings are absent');
                }
                return [2 /*return*/];
        }
    });
}); };
